export const STATUS_MAP = {
  0: { key: 'pending', label: 'Pending', color: '#FC8601' },
  1: { key: 'approving', label: 'Awaiting Approve', color: '#FC8601' },
  2: { key: 'approved', label: 'Approved', color: '#FFF' },
  3: { key: 'rejected', label: 'Rejected', color: '#FFF' },
  4: { key: 'inactive', label: 'Inactive', color: '#FFF' },
  5: { key: 'default', label: '-', color: '#000' },
}

export const APPROVAL_STEP_CLASS_MAP = {
  pending: 'approval-step-pending',
  approving: 'approval-step-approving',
  approved: 'approval-step-approved',
  rejected: 'approval-step-reject',
  inactive: 'approval-step-inactive',
  default: 'approval-step-requester',
}
